import React, { Component } from "react";
import { connect } from "react-redux";


class CommentsVoyage extends Component {
    constructor(props){
        super(props)
        this.state={
            comments:[]
        }
    }

    render() {
        return(
            <>
            <div className="commentVoyage p-3">
                  <h5 className="text-center mb-5"> Commentaires</h5>
                  <div className=" border-bottom row py-3">
                    <img src="/imgs/profilePic/profile.png" className="commentPicVoyage p-1 col-2" alt="" />
                    <div className="head col-10 ">
                      <div className=" d-flex">
                        <h3 className="font-weight-bold"> mahfoud la rome </h3>
                        <p className="my-auto px-4"> 14/07/2021 </p>
                      </div>
                      <p className="my-1">
                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Illum ipsam ratione ea nostrum, ipsa corporis.
                        {/* Lorem ipsum dolor sit amet consectetur adipisicing elit. Illum ipsam ratione ea nostrum, ipsa corporis. */}
                      </p>
                    </div>

                  </div>

                  <div className=" border-bottom  row py-3">
                    <img src="/imgs/profilePic/profile.png" className="commentPicVoyage p-1 col-2" alt="" />
                    <div className="head col-10 ">
                      <div className=" d-flex">
                        <h3 className="font-weight-bold"> mahfoud la rome </h3>
                        <p className="my-auto px-4"> 14/07/2021 </p>
                      </div>
                      <p className="my-1">
                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Illum ipsam ratione ea nostrum, ipsa corporis.
                        {/* Lorem ipsum dolor sit amet consectetur adipisicing elit. Illum ipsam ratione ea nostrum, ipsa corporis. */}
                      </p>
                    </div>

                  </div>

                  <div className=" border-bottom  row py-3">
                    <img src="/imgs/profilePic/profile.png" className="commentPicVoyage p-1 col-2" alt="" />
                    <div className="head col-10 ">
                      <div className=" d-flex">
                        <h3 className="font-weight-bold"> mahfoud la rome </h3>
                        <p className="my-auto px-4"> 14/07/2021 </p>
                      </div>
                      <p className="my-">
                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Illum ipsam ratione ea nostrum, ipsa corporis.
                        {/* Lorem ipsum dolor sit amet consectetur adipisicing elit. Illum ipsam ratione ea nostrum, ipsa corporis. */}
                      </p>
                    </div>
                  </div>
                </div>
            </>
        )

    }
}
function mapStateToProps(state) {
    return {
      
    };
  }
export default connect(mapStateToProps)(CommentsVoyage);
